import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecabs() {



    const cardData = {




keyword: "Mumbai Airport to Pune Cabs",

headingDescription: "Shreesha Tours & Travels offers reliable, comfortable, and affordable Mumbai Airport to Pune cab services with 24/7 pickup from Chhatrapati Shivaji Maharaj International Airport (T1 & T2). We provide one-way airport transfers, round-trip taxi services, corporate travel, hotel transfers, and customized outstation travel solutions for business travelers, families, tourists, students, NRIs, and corporate clients. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement and group size. Our professional chauffeurs track your flight schedule to ensure timely airport pickup, even in case of flight delays. With transparent pricing, doorstep drop anywhere in Pune, easy online booking, and 24/7 customer support, Shreesha Tours & Travels guarantees a safe, smooth, and hassle-free airport transfer. Whether you are traveling for business meetings, IT company visits, educational purposes, family functions, medical appointments, or holidays, our Mumbai Airport to Pune cab service offers clean vehicles, experienced drivers, and a comfortable journey via the Mumbai–Pune Expressway with complete travel convenience.",

topPlaces: [
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune's most famous historical landmark and the former seat of the Peshwas. The magnificent fort features grand gateways, beautiful gardens, ancient architecture, and an evening light-and-sound show that showcases the glorious Maratha history."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune's most significant heritage monuments, known for its beautiful architecture, lush gardens, and association with Mahatma Gandhi and India's freedom movement. It is a must-visit destination for history lovers."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Shreemant Dagdusheth Halwai Ganpati Temple is one of Maharashtra's most revered Lord Ganesha temples. Thousands of devotees visit the temple every day to seek blessings and admire its beautifully decorated idol and peaceful spiritual atmosphere."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a historic hill fort associated with Chhatrapati Shivaji Maharaj and Tanaji Malusare. It is famous for its trekking trails, panoramic mountain views, ancient structures, and delicious local Maharashtrian food served at the hilltop."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular picnic destination near Pune, offering scenic water views, pleasant weather, roadside food stalls, and beautiful sunset points. It is an ideal place for families, couples, and nature lovers."
  },
  {
    title: "Rajiv Gandhi IT Park, Hinjawadi",
    description: "Hinjawadi is Pune's largest IT and corporate hub, housing leading multinational companies, technology parks, and business centers. It is one of the most common destinations for travelers arriving from Mumbai Airport."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity is one of Pune's largest shopping and entertainment destinations, featuring international brands, restaurants, gaming zones, multiplex cinemas, and family entertainment under one roof."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. The temple's peaceful surroundings and remarkable architecture make it a popular attraction for devotees and history enthusiasts."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases an extensive collection of traditional Indian artifacts, musical instruments, sculptures, textiles, weapons, and decorative items, providing visitors with a glimpse into India's rich cultural heritage."
  },
  {
    title: "Mulshi Dam",
    description: "Located a short drive from Pune, Mulshi Dam is a scenic destination surrounded by lush green hills, backwaters, waterfalls, and picturesque landscapes. It is a favorite weekend getaway for couples, families, and nature enthusiasts."
  }
],



"services": [
  {
    "name": "Mumbai Airport to Pune Cabs",
    "description": "Book Mumbai Airport to Pune Cabs for safe, comfortable, and reliable airport transfers with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for family travel, business trips, corporate transfers, and one way journeys with convenient airport pickup from all terminals."
  },
  {
    "name": "Mumbai to Pune Cab Service",
    "description": "Hire Mumbai to Pune Cab Service for smooth and hassle-free travel with experienced drivers, clean vehicles, transparent pricing, and flexible one way or round trip booking options. Enjoy comfortable transportation for personal, family, and corporate travel."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Fare",
    "description": "Check Mumbai Airport to Pune Taxi Fare with affordable and transparent pricing. Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles for budget-friendly airport transfers without hidden charges."
  },
  {
    "name": "Taxi from Mumbai Airport to Pune",
    "description": "Book Taxi from Mumbai Airport to Pune for reliable airport pickup with professional chauffeurs, comfortable AC vehicles, and timely service. Enjoy a stress-free journey directly from the airport to your destination in Pune."
  },
  {
    "name": "Mumbai Pune Cab One Way",
    "description": "Choose Mumbai Pune Cab One Way for economical single-trip travel without return charges. Get fixed fares, experienced drivers, clean vehicles, and convenient pickup from Mumbai Airport."
  },
  {
    "name": "Mumbai to Pune Cab from Airport",
    "description": "Reserve Mumbai to Pune Cab from Airport for direct transfers with comfortable vehicles, professional chauffeurs, and flexible pickup schedules from Mumbai Airport terminals."
  },
  {
    "name": "Mumbai Airport Terminal 2 to Pune Cab",
    "description": "Book Mumbai Airport Terminal 2 to Pune Cab with instant pickup, reliable drivers, and premium AC vehicles. Enjoy comfortable transportation from T2 Airport to any location in Pune."
  },
  {
    "name": "Mumbai Airport to Pune Cab Fare",
    "description": "Get the best Mumbai Airport to Pune Cab Fare with competitive pricing, quality vehicles, and experienced chauffeurs. Travel safely with transparent fare policies and convenient booking."
  },
  {
    "name": "Mumbai International Airport to Pune Cab",
    "description": "Hire Mumbai International Airport to Pune Cab for dependable airport transfers with chauffeur-driven vehicles, timely pickup, and comfortable travel to Pune city and surrounding areas."
  },
  {
    "name": "Mumbai to Pune Taxi from Airport",
    "description": "Choose Mumbai to Pune Taxi from Airport for convenient travel with professional drivers, premium vehicles, and flexible one way or round trip options from Mumbai Airport."
  },
  {
    "name": "Best Cab Service from Mumbai Airport to Pune",
    "description": "Book the Best Cab Service from Mumbai Airport to Pune with well-maintained AC vehicles, experienced chauffeurs, affordable pricing, and 24x7 customer support for a smooth travel experience."
  },
  {
    "name": "Book Taxi from Mumbai Airport to Pune",
    "description": "Book Taxi from Mumbai Airport to Pune online with quick confirmation, multiple vehicle options, and doorstep drop service. Enjoy reliable airport transfers with comfortable seating and professional drivers."
  },
  {
    "name": "Cab Booking from Mumbai Airport to Pune",
    "description": "Complete Cab Booking from Mumbai Airport to Pune with simple online reservations, instant confirmation, transparent fares, and multiple cab categories suitable for every travel requirement."
  },
  {
    "name": "Cab Service from Mumbai Airport to Pune",
    "description": "Hire Cab Service from Mumbai Airport to Pune for reliable airport transportation with experienced chauffeurs, comfortable AC cars, and flexible pickup schedules available 24x7."
  },
  {
    "name": "Mumbai Airport Pickup and Drop to Pune",
    "description": "Book Mumbai Airport Pickup and Drop to Pune with punctual chauffeur service, clean vehicles, and convenient door-to-door transportation for business travelers, families, and tourists."
  },
  {
    "name": "Mumbai Airport Pune Cab",
    "description": "Choose Mumbai Airport Pune Cab for affordable and dependable airport transfers with Sedan, Ertiga, Innova Crysta, SUV, and premium cab options for comfortable long-distance travel."
  },
  {
    "name": "Mumbai Airport Pune Taxi Service",
    "description": "Reserve Mumbai Airport Pune Taxi Service for safe airport transfers with trained drivers, transparent pricing, and comfortable vehicles available for one way and round trip travel."
  },
  {
    "name": "Mumbai Airport to Pune Cab Charges",
    "description": "Check Mumbai Airport to Pune Cab Charges with affordable packages, fixed pricing, and premium chauffeur-driven vehicles for a comfortable and economical journey."
  },
  {
    "name": "Mumbai Airport to Pune Cab Service",
    "description": "Book Mumbai Airport to Pune Cab Service for reliable interstate airport transportation with experienced chauffeurs, spacious vehicles, and flexible travel schedules."
  },
  {
    "name": "Mumbai Airport to Pune Car Hire",
    "description": "Hire Mumbai Airport to Pune Car Hire services with chauffeur-driven vehicles for comfortable travel, business transfers, family trips, and convenient airport pickups."
  },
  {
    "name": "Mumbai Airport to Pune Car Rental",
    "description": "Choose Mumbai Airport to Pune Car Rental with professional drivers, clean AC vehicles, and multiple car categories for safe, comfortable, and reliable airport transfers."
  },
  {
    "name": "Mumbai Airport to Pune Drop",
    "description": "Book Mumbai Airport to Pune Drop service for direct one way transportation with punctual pickup, comfortable vehicles, and experienced chauffeurs at affordable prices."
  },
  {
    "name": "Mumbai Airport to Pune Innova",
    "description": "Reserve Mumbai Airport to Pune Innova for spacious and comfortable family or corporate travel with premium seating, extra luggage capacity, and professional chauffeur service."
  },
  {
    "name": "Mumbai Airport to Pune Prepaid Taxi Fare",
    "description": "Check Mumbai Airport to Pune Prepaid Taxi Fare for transparent pricing, fixed rates, and reliable airport taxi services with no hidden costs."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Online Booking",
    "description": "Complete Mumbai Airport to Pune Taxi Online Booking with instant confirmation, secure reservations, multiple vehicle choices, and 24x7 customer support for hassle-free airport transfers."
  }
],
"tableData": [
  ["Mumbai Airport to Pune Cabs", "Mumbai to Pune Cab Service"],
  ["Mumbai Airport to Pune Taxi Fare", "Taxi from Mumbai Airport to Pune"],
  ["Mumbai Pune Cab One Way", "Mumbai to Pune Cab from Airport"],
  ["Mumbai Airport Terminal 2 to Pune Cab", "Mumbai Airport to Pune Cab Fare"],
  ["Mumbai International Airport to Pune Cab", "Mumbai to Pune Taxi from Airport"],
  ["Best Cab Service from Mumbai Airport to Pune", "Book Taxi from Mumbai Airport to Pune"],
  ["Cab Booking from Mumbai Airport to Pune", "Cab Service from Mumbai Airport to Pune"],
  ["Mumbai Airport Pickup and Drop to Pune", "Mumbai Airport Pune Cab"],
  ["Mumbai Airport Pune Taxi Service", "Mumbai Airport to Pune Cab Charges"],
  ["Mumbai Airport to Pune Cab Service", "Mumbai Airport to Pune Car Hire"],
  ["Mumbai Airport to Pune Car Rental", "Mumbai Airport to Pune Drop"],
  ["Mumbai Airport to Pune Innova", "Mumbai Airport to Pune Prepaid Taxi Fare"],
  ["Mumbai Airport to Pune Taxi Online Booking", ""]
],




whychoose: [
  {
    WhyChooseheading: "Stress-Free Mumbai Airport to Pune Cab Transfers",
    WhyChoosedescription: "Arrive at Mumbai Airport and continue your journey to Pune without waiting for buses or trains. Shreesha Tours & Travels provides dedicated airport cabs with timely pickups and comfortable transfers."
  },
  {
    WhyChooseheading: "Flight-Based Pickup Scheduling",
    WhyChoosedescription: "Our team plans your pickup according to your flight arrival schedule, helping reduce unnecessary waiting time and making airport transfers smooth and convenient."
  },
  {
    WhyChooseheading: "Vehicles for Solo Travellers to Large Groups",
    WhyChoosedescription: "Book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles suitable for business travellers, families, students, and corporate groups."
  },
  {
    WhyChooseheading: "Direct Drop Anywhere in Pune",
    WhyChoosedescription: "We provide comfortable drop services to Hinjawadi, Baner, Kharadi, Wakad, Magarpatta, Hadapsar, Kothrud, Viman Nagar, Pimpri-Chinchwad, and every major area across Pune."
  },
  {
    WhyChooseheading: "Professional Airport Transfer Drivers",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with airport pickup procedures and expressway driving, ensuring a safe, punctual, and comfortable journey."
  },
  {
    WhyChooseheading: "One Way, Return & Corporate Airport Transfers",
    WhyChoosedescription: "Whether you require a one-way airport transfer, return pickup, employee transportation, or frequent corporate airport travel, we offer flexible booking options."
  },
  {
    WhyChooseheading: "Comfortable Luggage-Friendly Vehicles",
    WhyChoosedescription: "Travel with ease in spacious, air-conditioned vehicles designed to accommodate passengers along with their luggage comfortably."
  },
  {
    WhyChooseheading: "Quick Airport Cab Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai Airport to Pune cab easily with transparent pricing, prompt customer support, and reliable airport transfer services available throughout the year."
  }
]

};

const faqData = [
  {
    question: "Do you provide cab pickup from Mumbai Airport to Pune 24/7?",
    answer: "Yes, airport pickup services are available throughout the day and night based on advance booking and flight schedules."
  },
  {
    question: "Can I book a taxi directly from Terminal 1 or Terminal 2?",
    answer: "Yes, pickups can be arranged from both Mumbai Airport terminals with prior booking."
  },
  {
    question: "Do I need to share my flight details while booking?",
    answer: "Yes, sharing your flight number and arrival time helps us schedule your pickup more efficiently."
  },
  {
    question: "Which cars are available for Mumbai Airport to Pune travel?",
    answer: "You can choose Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book an airport cab for my office location in Pune?",
    answer: "Yes, we provide direct drop services to IT parks, business hubs, offices, hotels, residential societies, and all locations across Pune."
  },
  {
    question: "Is one-way airport transfer available?",
    answer: "Yes, one-way, return airport transfers, and customized travel packages are available according to your requirements."
  },
  {
    question: "Can families with extra luggage book larger vehicles?",
    answer: "Yes, spacious vehicles like Ertiga, Innova Crysta, SUVs, and Tempo Travellers are ideal for passengers carrying additional luggage."
  },
  {
    question: "How is the Mumbai Airport to Pune cab fare decided?",
    answer: "The fare depends on the selected vehicle category, pickup terminal, travel timing, and destination within Pune."
  },
  {
    question: "Do you provide airport cabs for corporate employees?",
    answer: "Yes, we regularly provide airport transfers for corporate executives, business travellers, and company employees."
  },
  {
    question: "How can I reserve a Mumbai Airport to Pune Cab?",
    answer: "Share your flight details, arrival time, terminal number, destination in Pune, passenger count, and preferred vehicle to receive your booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Joshi",
    feedback: "After landing at Mumbai Airport, our cab was ready exactly as scheduled. The driver was courteous, the Innova Crysta was spotless, and we reached Pune comfortably without any delay.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Kulshreshtha",
    feedback: "I frequently travel for work and use Shreesha Tours & Travels for airport transfers. Their Mumbai Airport to Pune cab service is punctual, reliable, and always provides a comfortable journey.",
    rating: 5
  }
];




















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-airport-to-pune-cabs.webp",
  "description":
    "Book Mumbai Airport to Pune Cabs with Shreesha Tours & Travels for safe, comfortable, and affordable airport transfer taxi services. We provide one-way and round-trip cabs from Mumbai Airport (T1 & T2) to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for corporate travel, family trips, hotel transfers, and business journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-airport-to-pune-cabs"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai Airport to Pune Cabs | Airport Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Pune Cabs with Shreesha Travels for reliable one-way and round-trip airport taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable transfers from Mumbai Airport Terminal 1 & 2 to Pune with 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Mumbai Airport to Pune Cabs, Mumbai to Pune Cab Service, Mumbai Airport to Pune Taxi Fare, Taxi from Mumbai Airport to Pune, Mumbai Pune Cab One Way, Mumbai to Pune Cab from Airport, Mumbai Airport Terminal 2 to Pune Cab, Mumbai Airport Terminal 1 to Pune Cab, Mumbai Airport to Pune Taxi, Mumbai Airport to Pune Cab Booking, Mumbai Airport to Pune Outstation Cab, Pune Airport Transfer from Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaiairporttopunecabs;